<template>
  <div class="c_chip__container">
    <div class="c_chip" :style="`--chip-background:${chipStyle};`">
      <slot />
    </div>
  </div>
</template>

<script>
import { defineComponent, toRefs, reactive } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'Chip',
  props: {
    theme: { type: String, required: false, default: 'yellow' },
  },
  setup(props) {
    const state = reactive({
      chipStyle: props.theme,
    });
    return {
      ...toRefs(state),
    };
  },
});
</script>

<style lang="scss">
.c_chip__container {
  display: flex;
  align-items: flex-start;
}
.c_chip {
  font-size: px_to_rem(14);
  @include font('graphik_regular');
  color: $color_black;
  background-color: var(--chip-background);
  border-radius: px_to_rem(5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: px_to_rem(8);
  line-height: 1;
  margin-bottom: px_to_rem(16);
}
</style>
